import gql from 'graphql-tag';

import { clientWeb } from '../graphqlAPI';

const USER_PASSWORD_RECOVER_USER_SENDS_PASSWORD = gql`
  mutation Post($email: String!, $password: String!, $code: String!) {
    userPasswordRecoverUserSendsNewPassword(
      email: $email,
      password: $password,
      code: $code,
      ){
        isValid
        token
        error
    }
}`;

const userPasswordRecoverUserSendsNewPassword = async ({
  email, password, code,
}) => {
  try {
    const result = await clientWeb.mutate({
      mutation: USER_PASSWORD_RECOVER_USER_SENDS_PASSWORD,
      variables: {
        email, password, code,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { userPasswordRecoverUserSendsNewPassword: validatedFormData } } = result;

    if (validatedFormData) {
      return validatedFormData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: validatedFormData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: userPasswordRecoverUserSendsNewPassword Error: ${error}`);
    return null;
  }
};

export default userPasswordRecoverUserSendsNewPassword;
